import React from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {TableWrapper} from '@/components/table/TableWrapper'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'
import {ModalWrapperProps} from '@/components/table/core/_types'
import {Modal} from '@/components/table/modal/Modal'
import {getTickets} from '../core/_requests'
import {SupportTicket} from '../core/_models'
import {TicketOverview} from './components/TicketOverview'
import {Columns} from './columns/_columns'
import {FilterForm, initialFilters} from './components/FilterForm'

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}, {
  title: 'Passtocard',
  path: '/p2c/dashboard',
}])

/**
 * Modal wrapper to manage open modal
 */
const ModalWrapper = ({itemForUpdate, action}: ModalWrapperProps) => {
  return (
    <>
      {itemForUpdate && action === 'details' && (
        <Modal title="Ticket details">
          <TicketOverview ticket={(itemForUpdate as SupportTicket)} />
        </Modal>
      )}
    </>
  )
}


const ListWrapper = () => (
  <>
    <PageTitle breadcrumbs={Breadcrumbs}>Support</PageTitle>
    <TableWrapper
      dataProvider={getTickets}
      cols={Columns}
      queryId="P2C_SUPPORT_LIST"
      modals={ModalWrapper}
      lookup={{placeholder: 'Search Ticket', fields: ['username', 'email']}}
      filters={{
        formFields: FilterForm,
        initialValues: initialFilters
      }}
    />
  </>
)

export default ListWrapper
